<template>
  <q-dialog
    :data-test="CypressTarget('DiscountCouponDialog')"
    :value="value"
    @input="$emit('input', $event)"
  >
    <span
      slot="title"
      :data-test="CypressTarget('Title')"
    >
      {{ $t('dialog.discountCoupon.title') }}
    </span>
    <span
      slot="message"
      :data-test="CypressTarget('Text')"
    >
      {{ $t('dialog.discountCoupon.text') }}
    </span>
    <div slot="body">
      <div class="row q-ma-sm">
        <div class="col-12">
          <q-field>
            <q-input
              v-model="couponCode"
              :data-test="CypressTarget('Input')"
              :color="SET_COLOR.primary"
              :float-label="$t('field.payment.discount.code')"
              type="text"
              class="event-coupon-code"
              required
            />
          </q-field>
        </div>
      </div>
    </div>
    <template
      slot="buttons"
      slot-scope="props"
    >
      <div :data-test="CypressTarget('Buttons')">
        <q-btn
          :label="$t('button.cancel')"
          :data-test="CypressTarget('Cancel')"
          :color="SET_COLOR.buttons.cancel || 'dark'"
          flat
          @click.native="props.cancel"
        />
        <q-btn
          :data-test="CypressTarget('Ok')"
          :disable="couponCode === ''"
          :label="$t('button.ok')"
          :color="SET_COLOR.buttons.ok || 'dark'"
          flat
          @click="setCoupon(props.ok, couponCode)"
        />
      </div>
    </template>
  </q-dialog>
</template>

<script>
  export default {
    name: 'DialogCheckoutDiscountCoupon',
    props: {
      value: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data: () => ({
      couponCode: '',
    }),
    methods: {
      async setCoupon(okFn, couponCode) {
        if (!couponCode) {
          return false;
        }
        await okFn();
        this.$emit('couponApplied', couponCode);
        this.$emit('input', false);
        this.couponCode = '';
        return true;
      },
    },
  };
</script>
